import tus from 'tus-js-client';
import {getAuthorizationHeader} from '@netx/core-auth-next/utils/getAuthorizationHeader';
import {UPPY_TUS_ENDPOINT} from '../../config';
import type {TusOptions as ITusOptions} from '../../lib/multi-destination';
import type {AnyUppyFile} from '../../types';
import {getUploadChunkSize} from '../getUploadChunkSize';

export type TusOptions = Partial<ITusOptions>;

export const tusOnBeforeRequest = async (
	req: tus.HttpRequest,
	file: AnyUppyFile,
) => {
	const authHeader = getAuthorizationHeader();
	req.setHeader(Object.keys(authHeader)[0], Object.values(authHeader)[0]);
	// DAM-21412:
	// uppy is not setting a content-type on the first post for the TUS endpoint
	// AND not having a content-type breaks (netx) CORS
	// req.getHeader('Content-Type')
	if ((req as any)._headers['Content-Type'] == null) {
		req.setHeader('Content-Type', `text/plain`);
	}
};

/**
 * Utility for creating uppy tus plugin options
 * @param options overrides
 * @returns Uppy tus plugin options
 */
export const createTusOptions = (options?: TusOptions) => {
	const tusOptions: ITusOptions = {
		endpoint: UPPY_TUS_ENDPOINT,
		removeFingerprintOnSuccess: true,
		chunkSize: getUploadChunkSize(),
		onBeforeRequest: tusOnBeforeRequest,
		...options,
	};

	return tusOptions;
};

export default createTusOptions;
